import { createApi } from '@reduxjs/toolkit/query/react';

import { ChatbotThread, TChatbot, TChatbotListParams, TCreateChatbotParams, TUpdateChatbotParams } from '@/types/chatbot';

import { baseQueryWithReauth } from './utils';

export const chatbotsApi = createApi({
  reducerPath: 'chatbotsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getChatbots: build.query({
      query: (params: TChatbotListParams) => ({
        url: 'chatbot/get-chatbots',
        method: 'POST',
        body: {
          ...params,
        },
      }),
    }),
    toggleChatbotPublished: build.mutation({
      query: (params: { referenceId: string }) => ({
        url: 'chatbot/toggle-published',
        method: 'PUT',
        params,
      }),
    }),
    deleteChatbot: build.mutation({
      query: (params: { referenceId: string }) => ({
        url: 'chatbot',
        method: 'DELETE',
        params,
        responseHandler: (response) => response.text(),
      }),
    }),
    getChatbotModels: build.query({
      query: (params: { llm: string }) => ({
        url: 'chatbot/get-models',
        method: 'GET',
        params,
      }),
    }),
    createChatbot: build.mutation({
      query: (params: TCreateChatbotParams) => ({
        url: 'chatbot',
        method: 'POST',
        body: params,
        transformResponse: (response: TChatbot) => response,
      }),
    }),
    getChatbot: build.query({
      query: (params: { referenceId: string }) => ({
        url: 'chatbot',
        method: 'GET',
        params,
        transformResponse: (response: TChatbot) => response,
      }),
    }),
    updateChatbot: build.mutation({
      query: (params: TUpdateChatbotParams) => ({
        url: 'chatbot',
        method: 'PATCH',
        body: params,
      }),
    }),
    getThread: build.query({
      query: (threadId: string) => {
        return {
          url: 'chatbot/get-thread',
          method: 'GET',
          params: { threadId },
        };
      },
      transformResponse: (response: ChatbotThread) => response,
    }),
  }),
});

export const {
  useGetChatbotsQuery,
  useToggleChatbotPublishedMutation,
  useDeleteChatbotMutation,
  useGetChatbotModelsQuery,
  useCreateChatbotMutation,
  useGetChatbotQuery,
  useUpdateChatbotMutation,
  useGetThreadQuery,
  useLazyGetThreadQuery,
} = chatbotsApi;
